export const SelectAutoFill = (target: HTMLSelectElement) => {

  const el = {
    root: target,
  }

  const method = {
    init: () => {
      el.root.addEventListener('change', method.onChange)
    },

    onChange: (e: Event & { target: HTMLSelectElement }) => {
      const selected = e.target.querySelector<HTMLOptionElement>('option:checked')
      if (!selected) return
      const { address = '', zip = '' } = selected.dataset

      const {
        address: addressInputName,
        zip: zipInputName,
      } = e.target.dataset

      const addressInput = document.querySelector<HTMLInputElement>(`input[name="${addressInputName}"]`)
      const zipInput = document.querySelector<HTMLInputElement>(`input[name="${zipInputName}"]`)

      if (addressInput) addressInput.value = address
      if (zipInput) zipInput.value = zip
    }
  }

  method.init()
}